// App-wide config can go here
export const PORTAL_LINK = process.env.REACT_APP_PORTAL_LINK
export const EDIT_PROFILE_LINK = process.env.REACT_APP_EDIT_PROFILE_LINK
export const PRIVACY_POLICY_LINK = process.env.REACT_APP_PRIVACY_POLICY_LINK
export const TERMS_CONDITIONS_LINK = process.env.REACT_APP_TERMS_OF_USE_LINK
export const CONTACT_LINK = process.env.REACT_APP_CONTACT_LINK

export const S3_UPLOAD_URL = process.env.REACT_APP_S3_UPLOAD_URL
export const CONTENTFUL_ASSETS_HOSTNAMES = [
  'images.secure.ctfassets.net',
  'videos.secure.ctfassets.net',
  'assets.secure.ctfassets.net',
  'downloads.secure.ctfassets.net'
]

// Mixpanel Configuration
export const MIXPANEL_PROJECT_ID = process.env.REACT_APP_MIXPANEL_PROJECT_ID

// Chameleon Configuration
export const CHAMELEON_TOKEN = process.env.REACT_APP_CHAMELEON_TOKEN
export const CHAMELEON_ENABLED = process.env.REACT_APP_CHAMELEON_ENABLED === 'true'

// Sentry Configuration
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
export const RELEASE_NUMBER = process.env.REACT_APP_RELEASE_NUMBER